import BaseAPIService from 'src/services/base/base-api-service';
import BaseModel from 'src/model/base.model';
import SubcategoryFilter from 'src/model/subcategoryFilter.model';
import env from 'src/shared/env';

/**
 * This endpoint can receive the next params
 * username: string,
 * password: string
 */

class SubcategoryService extends BaseAPIService<BaseModel> {
  private basicURL: string = env.REACT_APP_BASE_API_URL;

  private buildSubcategoryProductsEndpoint(categoryId: string) {
    return `${this.basicURL}navapp/v1/subcategory/category/${categoryId}`;
  }

  private buildProductsEndpoint(categoryId: string) {
    return `${this.basicURL}navapp/v1/product/subcategory/${categoryId}`;
  }

  private buildSubcategoriesFilterListEndpoint(subcategoryId: string) {
    return `${this.basicURL}navapp/v1/subcategory/${subcategoryId}/filter`;
  }

  private buildSubcategoriesBrandListEndpoint(subcategoryId: string) {
    return `${this.basicURL}navapp/v1/subcategory/${subcategoryId}/brands`;
  }

  private buildSubcategoriesAttributeListEndpoint(subcategoryId: string) {
    return `${this.basicURL}navapp/v1/subcategory/${subcategoryId}/attributes`;
  }

  private buildSubcategoriesFilteredEndpoint(
    subcategoryId: string,
    filters: SubcategoryFilter[],
    selectionType: string
  ) {  
  const regExp = /\(([^)]+)\)/;
  let filterUrl = '';  
  let filterTypeVal = '';
  console.log("selected brands",filters);
    if(filters.length >0) {       
      filters.map((item: any, index: number) => {
        if (!item.filterType || item.filterType === 'undefined') {
          filterTypeVal = 'filter';
        } else {
          filterTypeVal = item.filterType;
        } 
    const prefix = filterUrl !== '' ? '&' : ''; 

    const brandSelectedVal = filterTypeVal === 'brand' ? item.manufacturerCode : item.name;

    filterUrl += `${prefix}${filterTypeVal}=${encodeURIComponent(brandSelectedVal)}`;      
    })}   
    return encodeURI(
      `${this.basicURL}navapp/v1/product/subcategory/${subcategoryId}?${filterUrl}`
    );    
  }

  public getSubcategories(categoryId: string) {
    const endpoint: string = this.buildSubcategoryProductsEndpoint(categoryId);

    return new Promise((resolve, reject) => {
      this.getAll(endpoint)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getProductsBySubcategory(
    subcategoryId: string,
    customerId: string,
    pageNumber: number = 0,
    productsPerPage: number
  ) {
    const endpoint: string = this.buildProductsEndpoint(subcategoryId);
    return new Promise((resolve, reject) => {
      this.getOneByParams(endpoint, {
        page: pageNumber,
        size: productsPerPage
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getSubcategoriesFilters(subcategoryId: string) {
    const endpoint: string = this.buildSubcategoriesFilterListEndpoint(
      subcategoryId
    );
    return new Promise((resolve, reject) => {
      this.getOneByParams(endpoint)
        .then((response: any) => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getSubcategoriesBrands(subcategoryId: string) {
    const endpoint: string = this.buildSubcategoriesBrandListEndpoint(
      subcategoryId
    );
    return new Promise((resolve, reject) => {
      this.getBrandsOneByParams(endpoint)
        .then((response: any) => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getSubcategoriesAttributes(subcategoryId: string) {
    const endpoint: string = this.buildSubcategoriesAttributeListEndpoint(
      subcategoryId
    );
    return new Promise((resolve, reject) => {
      this.getBrandsOneByParams(endpoint)
        .then((response: any) => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getSubcategoriesFiltered(
    subcategoryId: string,
    filters: SubcategoryFilter[],
    selectionType: string,
    pageNumber: number = 0,
    productsPerPage: number
    
  ) {
    const endpoint: string = this.buildSubcategoriesFilteredEndpoint(
      subcategoryId,
      filters,
      selectionType
    );
    return new Promise((resolve, reject) => {
      this.getOneByParams(endpoint, { page: pageNumber, size: productsPerPage })
        .then((response: any) => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

const subcategoryServiceInstance = new SubcategoryService(BaseModel);
Object.freeze(subcategoryServiceInstance);

export default subcategoryServiceInstance;
